import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/ui/Breadcrumb";
import routePaths from "../../routes/routePaths";
import SeoMeta from "../../components/ui/SeoMeta";

const ProgramDetailPage = () => {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const [program, setProgram] = useState(null);

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const q = query(
          collection(db, "programs"),
          where("slug", "==", slug),
          limit(1)
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          const data = snapshot.docs[0].data();
          setProgram(data);
        } else {
          console.warn("Không tìm thấy chương trình:", slug);
        }
      } catch (error) {
        console.error("Lỗi tải chương trình:", error);
      }
    };
    fetchProgram();
  }, [slug]);

  if (!program)
    return (
      <div className="p-6 text-center">{t("programs.loading")}</div>
    );

  const level = program.level?.[lang] || program.level?.vi || slug;
  const name = program.name?.[lang] || program.name?.vi || level;
  const description = program.description?.[lang] || program.description?.vi || "";
  const content = program.content?.[lang] || program.content?.vi || "";

  return (
    <div className="py-6 px-4">
      <SeoMeta page="program-detail-page" initialMeta={{title: `${name}`, description: "" }} />
      <Breadcrumb items={[
        { label: t("programs.breadcrumb"), path: routePaths.programs },
        { label: name }
      ]} />

      <div className="bg-card rounded-2xl border border-border shadow-sm p-8 mt-6">
        <h1 className="text-2xl md:text-2xl font-extrabold text-primary mb-3">{name}</h1>
        <div className="mb-6 text-lg text-menu">{description}</div>
        <div
          className="prose max-w-none
            prose-h2:text-menu
            prose-h3:text-primary
            prose-a:text-textLink
            prose-blockquote:border-l-primary
            prose-li:marker:text-primary
            text-text
          "
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default ProgramDetailPage;
